import React from 'react';
import { useTranslation } from 'react-i18next';
import { InfoButton } from './Description';
import { alarmHelp } from '../Constants/alarm_help';

export default function AlarmHelp({ ids, label }) {
  const { i18n } = useTranslation();
  const language = (i18n.language === 'keys' ? 'de' : i18n.language ?? 'en').toLowerCase().split(/[-_]/)[0];
  const blocks = ids.flatMap((id) => alarmHelp[id]?.[language] ?? alarmHelp[id]?.en ?? []);
  if (!blocks.length) return null;
  const content = blocks.map((block, index) => Array.isArray(block) ? (
    <ul key={index}>{block.map((item) => <li key={item}>{item}</li>)}</ul>
  ) : <p key={index}>{block}</p>);
  return <InfoButton content={content} img="" brief={label}
    ariaLabel={`${({ de: 'Hilfe', en: 'Help', fr: 'Aide', es: 'Ayuda', it: 'Aiuto' })[language] ?? 'Help'}: ${label}`} />;
}
